import React from 'react';
import "./Contact.css";
import { ContactBanner } from './BannerSection';
import { ContactSection } from '../Home/ContactSection';

export const Contact = () => {
  return (
    <div className='contactMainContainer'>
      <ContactBanner/>
      <ContactSection/>
    </div>
  )
}
